/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const vehicleType = async (): Promise<any> => {
  const vehicleType = useJSONStore.getState().vehicleType;
  const token = useUserStore.getState().userToken;
  const setVehicleType = useJSONStore.getState().setVehicleType;

  if (vehicleType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.vehicleType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setVehicleType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default vehicleType;
